import { render, staticRenderFns } from "./riwayatPenghargaan.vue?vue&type=template&id=ca092062&"
import script from "./riwayatPenghargaan.vue?vue&type=script&lang=js&"
export * from "./riwayatPenghargaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QIcon,QCardActions,QList,QExpansionItem,QMarkupTable,QFile,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QIcon,QCardActions,QList,QExpansionItem,QMarkupTable,QFile})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
